import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/about/components/about/about.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/about/components/advantages/advantages.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/about/components/benefit/benefit.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/about/components/roadmap/roadmap.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/about/components/start/start.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.20_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.101.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/cover/cover.png");
